// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see ThreeDsAuthenticationStartEvent
 */
export var ThreeDsAuthenticationStart = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "ThreeDs Authentication Start",
        parameters: {
            cdf_entity: "ThreeDs",
            cdf_action: "Authentication",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ThreeDsAuthenticationSdkInitializationSuccessEvent
 */
export var ThreeDsAuthenticationSdkInitializationSuccess = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "ThreeDs Authentication SdkInitializationSuccess",
        parameters: {
            cdf_entity: "ThreeDs",
            cdf_action: "Authentication",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ThreeDsAuthenticationSdkInitializationFailureEvent
 */
export var ThreeDsAuthenticationSdkInitializationFailure = function (_a) {
    var flowToken = _a.flowToken, failureMessage = _a.failureMessage;
    return ({
        name: "ThreeDs Authentication SdkInitializationFailure",
        parameters: {
            cdf_entity: "ThreeDs",
            cdf_action: "Authentication",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            failure_message: failureMessage !== undefined && failureMessage !== null ? failureMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ThreeDsAuthenticationDelayCompleteEvent
 */
export var ThreeDsAuthenticationDelayComplete = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "ThreeDs Authentication DelayComplete",
        parameters: {
            cdf_entity: "ThreeDs",
            cdf_action: "Authentication",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ThreeDsAuthenticationSdkWarningEvent
 */
export var ThreeDsAuthenticationSdkWarning = function (_a) {
    var flowToken = _a.flowToken, warningMessage = _a.warningMessage;
    return ({
        name: "ThreeDs Authentication SdkWarning",
        parameters: {
            cdf_entity: "ThreeDs",
            cdf_action: "Authentication",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            warning_message: warningMessage !== undefined && warningMessage !== null ? warningMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ThreeDsAuthenticationSdkFailureEvent
 */
export var ThreeDsAuthenticationSdkFailure = function (_a) {
    var flowToken = _a.flowToken, failureMessage = _a.failureMessage;
    return ({
        name: "ThreeDs Authentication SdkFailure",
        parameters: {
            cdf_entity: "ThreeDs",
            cdf_action: "Authentication",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            failure_message: failureMessage !== undefined && failureMessage !== null ? failureMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ThreeDsAuthenticationRequestCompleteEvent
 */
export var ThreeDsAuthenticationRequestComplete = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "ThreeDs Authentication RequestComplete",
        parameters: {
            cdf_entity: "ThreeDs",
            cdf_action: "Authentication",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ThreeDsAuthenticationRequestFailureEvent
 */
export var ThreeDsAuthenticationRequestFailure = function (_a) {
    var flowToken = _a.flowToken, failureMessage = _a.failureMessage;
    return ({
        name: "ThreeDs Authentication RequestFailure",
        parameters: {
            cdf_entity: "ThreeDs",
            cdf_action: "Authentication",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            failure_message: failureMessage !== undefined && failureMessage !== null ? failureMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
